<div class="form-group dayhour-input-list">
  <div #wrapper2 class="dayhour-input-group" *ngFor="let input of inputs; index as i">
    <app-hour-minute-input
      [control]="input"
      [disableMinute]="i !== 0"
      [title]="i !== 0 ? 'The minute has to be constant in every hour' : ''"
      (inputChange)="onChange()"
    ></app-hour-minute-input>
    <button
      [ngClass]="{'btn': true, 'btn-default': true, 'btn-xs': true, 'disabled': inputs.length === 1}"
      type="button"
      (click)="onRemoveClick(i)"
    ><i class="fa fa-remove fa-lg"></i></button>
  </div>
</div>
<div class="form-group actions">
  <a
    role="button"
    type="button"
    class="add-day"
    (click)="onAddClick()"
    i18n="Add another time button label used to add another pair of hour and minute in a multi-hour input"
  >Add another time</a>
</div>
